// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "-legacy." + {"132":"76f503ed","415":"b9260d87","606":"2c487226","838":"a1c7f6ee"}[chunkId] + ".js";
};